var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button, useMediaQuery, useTheme, CircularProgress, Box, } from "@mui/material";
import { SIconButton } from "./SIconButton";
export const SButton = (_a) => {
    var { mt = 0, variant = "contained", fullWidth = false, tooltip, responsiveIcon = false, loading = false, iconButtonBorderRadius, children } = _a, props = __rest(_a, ["mt", "variant", "fullWidth", "tooltip", "responsiveIcon", "loading", "iconButtonBorderRadius", "children"]);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    // Ensure buttons are at least "large" on mobile for better touch targets
    const buttonSize = isSmallScreen
        ? props.size === "small"
            ? "medium"
            : props.size || "large"
        : props.size;
    // Determine spinner size based on button size
    const spinnerSize = buttonSize === "small" ? 16 : buttonSize === "large" ? 24 : 20;
    // Determine spinner color based on variant
    const getSpinnerColor = () => {
        if (variant === "contained") {
            // For contained buttons, use contrast text color
            const colorKey = props.color;
            if (colorKey &&
                theme.palette[colorKey] &&
                typeof theme.palette[colorKey] === "object" &&
                "contrastText" in theme.palette[colorKey]) {
                return theme.palette[colorKey].contrastText;
            }
            return theme.palette.primary.contrastText;
        }
        // For outlined and text buttons, use main color
        const colorKey = props.color;
        if (colorKey &&
            theme.palette[colorKey] &&
            typeof theme.palette[colorKey] === "object" &&
            "main" in theme.palette[colorKey]) {
            return theme.palette[colorKey].main;
        }
        return theme.palette.primary.main;
    };
    if (responsiveIcon && isSmallScreen) {
        return (React.createElement(SIconButton, Object.assign({ colorVariant: props.color }, props, { sx: { borderRadius: iconButtonBorderRadius }, disabled: props.disabled || loading, title: tooltip, size: "small" }), loading ? (React.createElement(CircularProgress, { size: 16, sx: { color: getSpinnerColor() } })) : (props.startIcon || props.endIcon)));
    }
    return (React.createElement(Button, Object.assign({}, props, { variant: variant, fullWidth: fullWidth, size: buttonSize, disabled: props.disabled || loading, sx: Object.assign({ mt, position: "relative" }, props.sx) }),
        React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: 1,
                visibility: loading ? "hidden" : "visible",
            } }, children),
        loading && (React.createElement(CircularProgress, { size: spinnerSize, sx: {
                color: getSpinnerColor(),
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: `-${spinnerSize / 2}px`,
                marginLeft: `-${spinnerSize / 2}px`,
            } }))));
};
